import LoadingGif from '@images/loading.gif';

export const PageLoader = () => {
  return (
    <div className="fixed left-0 top-0 z-20 grid h-screen w-screen place-items-center">
      <img
        className="z-10 w-52 -translate-y-1/2"
        src={LoadingGif}
        alt="loading..."
      />
      <div className="fixed inset-0 bg-white/70" aria-hidden="true" />
    </div>
  );
};
